/* The rules behind /u1/membership/:companyId, transcribed from components/public/VerifyAccount/PaymentScreen.jsx. */

/* Transcribed: the two Stripe AED prices. These drive the display only — the
   amount charged comes back from create-checkout-session. */
export const PLAN_PRICES = { monthly: 99, yearly: 999 };

export const PLAN_YEARLY = "yearly";
export const PLAN_MONTHLY = "monthly";

/* TIP-494 — the dashboard entry can preselect a cycle via router state.
   Anything other than "monthly" falls to yearly, as the live default does. */
export const resolveBilling = (state) =>
  state?.plan === PLAN_MONTHLY ? PLAN_MONTHLY : PLAN_YEARLY;

export const priceOf = (billing) => PLAN_PRICES[billing];

export const priceSuffix = (billing) =>
  billing === PLAN_YEARLY ? "/ year" : "/ month";

/* The line under the price. Yearly shows what it works out to per month —
   rounded, as the live screen rounds it. */
export const priceNote = (billing) =>
  billing === PLAN_YEARLY
    ? { monthlyEquivalent: Math.round(PLAN_PRICES.yearly / 12) }
    : { text: "Billed monthly · upgrade or cancel any time" };

export const planLabel = (billing) =>
  billing === PLAN_YEARLY ? "Annual" : "Monthly";

/* Whose membership this is.
 *
 * TIP-488 — the company can arrive three ways, and the live precedence is:
 * the name passed in router state, then the lead's own company (verify-account
 * flow only, which is what the token gates), then a placeholder once there is
 * at least an id to act on.
 */
export const resolveCompanyName = ({ stateName, lead, token, companyID } = {}) =>
  stateName ||
  (token ? lead?.verify_data?.company?.name || "Your business" : "") ||
  (companyID ? "your business" : "");

/* The id can come from the route (the reusable /membership/:companyId) or from
   the verify-account flow's navigation state. */
export const resolveCompanyId = ({ companyIdProp, stateCompanyId } = {}) =>
  companyIdProp || stateCompanyId;

/* Transcribed guard: with neither an id nor a name there is nothing to enrol,
   so the screen bails to the home page rather than starting a checkout that
   cannot be attributed. */
export const shouldBail = ({ companyID, companyName }) =>
  !companyID && !companyName;

/* What to tell the buyer when checkout will not start. The API's own detail
   wins; otherwise the status code is surfaced rather than swallowed, because
   "try again" with no reason is what the live screen was careful to avoid. */
export const checkoutErrorMessage = (e) =>
  e?.data?.detail ||
  `Couldn't start checkout (HTTP ${e?.status || "?"}). Please try again.`;

/* The six selling points, in the live order. `highlighted` marks the one the
   design tints — free verification, the reason most businesses upgrade. */
export const BENEFITS = [
  {
    key: "verification",
    icon: "shield",
    title: "Free verification",
    body: "Request the green ✓ verified badge at no extra cost — a member-only perk.",
    highlighted: true,
  },
  {
    key: "placement",
    icon: "rise",
    title: "Priority placement",
    body: "Members show first when buyers search your industry or city.",
  },
  {
    key: "ratings",
    icon: "star",
    title: "Member ratings",
    body: "Collect public ratings on your products and services from other TREVEX members.",
  },
  {
    key: "endorsements",
    icon: "card",
    title: "Payment endorsements",
    body: 'Businesses you trade with can endorse you as a "pays on time" payer — visible on your profile.',
  },
  {
    key: "partner",
    icon: "users",
    title: "Partner program claim",
    body: "Join the TREVEX referral network to earn commissions and unlock co-marketing.",
  },
  {
    key: "claimed",
    icon: "edit",
    title: "All Claimed benefits",
    body: "Edit business details, respond to enquiries, manage signatories — everything in Claimed.",
  },
];

/* The reassurance strip under the benefits. */
export const TRUST_POINTS = [
  { key: "refund", icon: "shield", label: "30-day money back" },
  { key: "stripe", icon: "lock", label: "Secure payment via Stripe" },
  { key: "cancel", icon: "check", label: "Cancel any time" },
];
